import settingsDrivingPermitService from '@/api/settings-driving-permit-service';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';

const state = {
  drivingPermitValidationErrors: {},
};

const mutations = {
  SET_DRIVING_PERMIT_VALIDATION_ERRORS(state, validationErrors) {
    state.drivingPermitValidationErrors = validationErrors;
  },

  CLEAR_VALIDATION_ERRORS(state, field) {
    delete state.drivingPermitValidationErrors[field];
  },
};

const actions = {
  createDrivingPermit({ commit }, drivingPermit) {
    return settingsDrivingPermitService
      .create(drivingPermit)
      .then((res) => {
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('driving_permit_created'));
      })
      .catch((err) => {
        commit('SET_DRIVING_PERMIT_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },

  clearDrivingPermitValidationErrors({ commit }, field) {
    commit('CLEAR_VALIDATION_ERRORS', field);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
